import { createContext, Dispatch } from "react";
import { Datasheet } from "@/api/datasheets";
import { Project } from "@/api/project";
import { StateType, WelderState, WeldListFilters } from "./types";
import { SubProject } from "@/api/subProject";
import { WelderRow, WelderWeld } from "@/api/cds/rbi";

export interface IWelderContext {
  state: WelderState;
  updateState: Dispatch<RbiAction>;
}

export const WelderContext = createContext<IWelderContext>({} as IWelderContext);

export type RbiAction = {
  type: StateType;
  payload?: Project | SubProject | Datasheet | WelderWeld[] | WelderRow[] | WeldListFilters;
};

export const reducer = (state: WelderState, action: RbiAction): WelderState => {
  switch (action.type) {
    case "Project":
      return { ...state, project: action.payload as Project, subProject: undefined, datasheet: undefined };
    case "SubProject":
      return { ...state, subProject: action.payload as SubProject, datasheet: undefined };
    case "Datasheet":
      return { ...state, datasheet: action.payload as Datasheet, welds: [], processes: [] };
    case "Welds":
      return { ...state, welds: action.payload as WelderWeld[], processes: [] };
    case "Processes":
      return { ...state, processes: action.payload as WelderRow[] };
    case "Filters":
      return { ...state, filters: action.payload as WeldListFilters, welds: [], processes: [] };
    default:
      return state;
  }
};
